import { useEffect, useState } from 'react';
import PortalService from '../../services/portal/portal.service';
import { profileImageService } from '../../services/profile/profileImage.service';

/** The signed-in guardian's own profile photo; null when none (or the read fails). Initials are the fallback. */
export function useGuardianPhoto(): string | null {
  const [url, setUrl] = useState<string | null>(null);
  useEffect(() => {
    let cancelled = false;
    profileImageService
      .getProfileImage()
      .then((result) => {
        if (!cancelled) setUrl(result.hasProfilePicture ? result.imageUrl : null);
      })
      .catch(() => undefined);
    return () => {
      cancelled = true;
    };
  }, []);
  return url;
}

/** The selected patient's photo (from the demographics allow-list). Gate or read errors just mean "no photo". */
export function usePatientPhoto(patientId: string | null): string | null {
  const [url, setUrl] = useState<string | null>(null);
  useEffect(() => {
    setUrl(null);
    if (!patientId) return undefined;
    let cancelled = false;
    PortalService.getDemographics(patientId)
      .then((data) => {
        if (!cancelled) setUrl(data.pictureUrl);
      })
      .catch(() => undefined);
    return () => {
      cancelled = true;
    };
  }, [patientId]);
  return url;
}
